import { useState } from 'react';
import Chat from './components/Chat';
import config from './config';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('chat');

  const renderProjectDescription = (project) => {
    if (!project.awardLink || !project.awardText) {
      return project.description;
    }

    const parts = project.description.split('{award}');
    return (
      <>
        {parts[0]}
        <a href={project.awardLink} className="social-link" target="_blank" rel="noopener noreferrer">
          {project.awardText}
        </a>
        {parts[1]}
      </>
    );
  };

  const PortfolioPage = () => (
    <div className="portfolio-page">
      <main className="main-content">
        <p className="bio">{config.bio}</p>

        <section className="projects-section">
          <h2 className="section-title">projects</h2>

          {config.projects.map((project) => (
            <div className="project" key={project.name}>
              <h3 className="project-name">
                <a href={project.link} className="project-link" target="_blank" rel="noopener noreferrer">
                  {project.name}
                </a>
              </h3>
              <p className="project-description">
                {renderProjectDescription(project)}
              </p>
            </div>
          ))}
        </section>
      </main>
    </div>
  );

  return (
    <div className="app">
      <header className="app-header">
        <h1
          className="app-name"
          onClick={() => setCurrentPage('chat')}
        >
          {config.name}
        </h1>
        <nav className="header-nav">
          <button
            className={`nav-tab ${currentPage === 'portfolio' ? 'active' : ''}`}
            onClick={() => setCurrentPage('portfolio')}
          >
            about
          </button>
          <div className="header-links">
            {config.socials.map((social) => (
              social.internal ? (
                <button
                  key={social.key}
                  className={`nav-tab ${currentPage === social.key ? 'active' : ''}`}
                  onClick={() => setCurrentPage(social.key)}
                >
                  {social.label}
                </button>
              ) : (
                <a key={social.key} href={social.url} target="_blank" rel="noopener noreferrer">
                  {social.label}
                </a>
              )
            ))}
          </div>
          <button
            className={`nav-tab ${currentPage === 'chat' ? 'active' : ''}`}
            onClick={() => setCurrentPage('chat')}
          >
            chat
          </button>
        </nav>
      </header>

      {currentPage === 'chat' ? <Chat /> : currentPage === 'writings' ? (
        <div className="portfolio-page">
          <main className="main-content">
            <p className="bio">
              coming soon! thoughts on tech, startups, life, and everything i'm learning along the way.
            </p>
          </main>
        </div>
      ) : <PortfolioPage />}

      <footer className="app-footer">
        {config.footer}
      </footer>
    </div>
  );
}

export default App;
